/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AiFeedback,
  AiFeedbackRequestInput,
  ListAiFeedbackResultsParams,
  ListAiFeedbacksParams,
  PaginatedAiFeedbackResults,
  PaginatedAiFeedbacks,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create AI Feedback
 */
export const createAiFeedback = (
    aiFeedbackRequestInput: MaybeRefOrGetter<AiFeedbackRequestInput>,
 signal?: AbortSignal
) => {
      aiFeedbackRequestInput = toValue(aiFeedbackRequestInput);

      return axiosClient<AiFeedback>(
      {url: `/ai/feedbacks`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aiFeedbackRequestInput, signal
    },
      );
    }




export const getCreateAiFeedbackMutationKey = () => ['createAiFeedback'] as const;

export const getCreateAiFeedbackMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiFeedback>>, TError,CreateAiFeedbackMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAiFeedback>>, TError,CreateAiFeedbackMutationVariables, TContext> => {

const mutationKey = getCreateAiFeedbackMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAiFeedback>>, CreateAiFeedbackMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createAiFeedback(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAiFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof createAiFeedback>>>
    export type CreateAiFeedbackMutationBody = AiFeedbackRequestInput
    export type CreateAiFeedbackMutationError = ErrorType<void>
    export type CreateAiFeedbackMutationVariables = {data: AiFeedbackRequestInput}

    /**
 * @summary Create AI Feedback
 */
export const useCreateAiFeedback = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiFeedback>>, TError,CreateAiFeedbackMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createAiFeedback>>,
        TError,
        CreateAiFeedbackMutationVariables,
        TContext
      > => {
      return useMutation(getCreateAiFeedbackMutationOptions(options), queryClient);
    }
    /**
 * @summary List of AI Feedbacks
 */
export const listAiFeedbacks = (
    params?: MaybeRefOrGetter<ListAiFeedbacksParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedAiFeedbacks>(
      {url: `/ai/feedbacks`, method: 'GET',
        params, signal
    },
      );
    }




export const getListAiFeedbacksQueryKey = (params?: MaybeRefOrGetter<ListAiFeedbacksParams>,) => {
    return [
    'ai','feedbacks', ...(params ? [params] : [])
    ] as const;
    }


export const getListAiFeedbacksQueryOptions = <TData = Awaited<ReturnType<typeof listAiFeedbacks>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListAiFeedbacksParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiFeedbacks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiFeedbacksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiFeedbacks>>> = ({ signal }) => listAiFeedbacks(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAiFeedbacks>>, TError, TData>
}

export type ListAiFeedbacksQueryResult = NonNullable<Awaited<ReturnType<typeof listAiFeedbacks>>>
export type ListAiFeedbacksQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of AI Feedbacks
 */

export function useListAiFeedbacks<TData = Awaited<ReturnType<typeof listAiFeedbacks>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListAiFeedbacksParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiFeedbacks>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAiFeedbacksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary List of AI Feedback Results
 */
export const listAiFeedbackResults = (
    feedbackId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListAiFeedbackResultsParams>,
 signal?: AbortSignal
) => {
      feedbackId = toValue(feedbackId);
params = toValue(params);

      return axiosClient<PaginatedAiFeedbackResults>(
      {url: `/ai/feedbacks/${feedbackId}/feedback_results`, method: 'GET',
        params, signal
    },
      );
    }




export const getListAiFeedbackResultsQueryKey = (feedbackId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListAiFeedbackResultsParams>,) => {
    return [
    'ai','feedbacks',feedbackId,'feedback_results', ...(params ? [params] : [])
    ] as const;
    }


export const getListAiFeedbackResultsQueryOptions = <TData = Awaited<ReturnType<typeof listAiFeedbackResults>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(feedbackId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListAiFeedbackResultsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiFeedbackResults>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiFeedbackResultsQueryKey(feedbackId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiFeedbackResults>>> = ({ signal }) => listAiFeedbackResults(feedbackId,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(feedbackId) !== null && toValue(feedbackId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAiFeedbackResults>>, TError, TData>
}

export type ListAiFeedbackResultsQueryResult = NonNullable<Awaited<ReturnType<typeof listAiFeedbackResults>>>
export type ListAiFeedbackResultsQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of AI Feedback Results
 */

export function useListAiFeedbackResults<TData = Awaited<ReturnType<typeof listAiFeedbackResults>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 feedbackId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListAiFeedbackResultsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiFeedbackResults>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAiFeedbackResultsQueryOptions(feedbackId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete AI Feedback
 */
export const deleteAiFeedback = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/ai/feedbacks/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteAiFeedbackMutationKey = () => ['deleteAiFeedback'] as const;

export const getDeleteAiFeedbackMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiFeedback>>, TError,DeleteAiFeedbackMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiFeedback>>, TError,DeleteAiFeedbackMutationVariables, TContext> => {

const mutationKey = getDeleteAiFeedbackMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiFeedback>>, DeleteAiFeedbackMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteAiFeedback(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiFeedback>>>

    export type DeleteAiFeedbackMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteAiFeedbackMutationVariables = {id: string}

    /**
 * @summary Delete AI Feedback
 */
export const useDeleteAiFeedback = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiFeedback>>, TError,DeleteAiFeedbackMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAiFeedback>>,
        TError,
        DeleteAiFeedbackMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteAiFeedbackMutationOptions(options), queryClient);
    }
    /**
 * @summary AI Feedback Details
 */
export const getAiFeedback = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<AiFeedback>(
      {url: `/ai/feedbacks/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetAiFeedbackQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'ai','feedbacks',id
    ] as const;
    }


export const getGetAiFeedbackQueryOptions = <TData = Awaited<ReturnType<typeof getAiFeedback>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiFeedback>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAiFeedbackQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiFeedback>>> = ({ signal }) => getAiFeedback(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAiFeedback>>, TError, TData>
}

export type GetAiFeedbackQueryResult = NonNullable<Awaited<ReturnType<typeof getAiFeedback>>>
export type GetAiFeedbackQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary AI Feedback Details
 */

export function useGetAiFeedback<TData = Awaited<ReturnType<typeof getAiFeedback>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiFeedback>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAiFeedbackQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update AI Feedback
 */
export const updateAiFeedback = (
    id: MaybeRefOrGetter<string>,
    aiFeedbackRequestInput: MaybeRefOrGetter<AiFeedbackRequestInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
aiFeedbackRequestInput = toValue(aiFeedbackRequestInput);

      return axiosClient<AiFeedback>(
      {url: `/ai/feedbacks/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: aiFeedbackRequestInput, signal
    },
      );
    }




export const getUpdateAiFeedbackMutationKey = () => ['updateAiFeedback'] as const;

export const getUpdateAiFeedbackMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiFeedback>>, TError,UpdateAiFeedbackMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAiFeedback>>, TError,UpdateAiFeedbackMutationVariables, TContext> => {

const mutationKey = getUpdateAiFeedbackMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAiFeedback>>, UpdateAiFeedbackMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateAiFeedback(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAiFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof updateAiFeedback>>>
    export type UpdateAiFeedbackMutationBody = AiFeedbackRequestInput
    export type UpdateAiFeedbackMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateAiFeedbackMutationVariables = {id: string;data: AiFeedbackRequestInput}

    /**
 * @summary Update AI Feedback
 */
export const useUpdateAiFeedback = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiFeedback>>, TError,UpdateAiFeedbackMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAiFeedback>>,
        TError,
        UpdateAiFeedbackMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateAiFeedbackMutationOptions(options), queryClient);
    }
